import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LockOpenedIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.56 19.8V9.52H14V6.92C14 5.76 13.22 4.84 12 4.84C10.78 4.84 10 5.76 10 6.92H8.24C8.24 4.86 9.92 3.2 12 3.2C14.08 3.2 15.76 4.86 15.76 6.92V9.52H17.44V19.8H6.56ZM8.32 18.04H15.68V11.28H8.32V18.04Z" />
    </SvgIcon>
  );
});
